import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import useCustomerDetails from "../../data/useCustomerDetails";
import { useFeatureEnabled } from "../../hooks/useFeatureFlag";
import EbayOrdersTable from "../../components/ebayOrders/EbayOrdersTable";
import EbayOrdersStats from "../../components/ebayOrders/EbayOrdersStats";
import OrdersOverview from "../../components/ebayOrders/OrdersOverview";

// Per customer, set in Barney. Off: the old order stats card. On: the warehouse overview in its place.
export const WAREHOUSE_OVERVIEW_FLAG = "Warehouse Overview";

export default function EbayOrders() {
  const { setInfo } = usePageNameContext();
  const { features } = useCustomerDetails();
  const warehouseOverview = useFeatureEnabled(WAREHOUSE_OVERVIEW_FLAG);

  useEffect(() => {
    setInfo({
      name: "Orders",
      desc: "View and manage sold parts",
    });
  }, []);

  return (
      <>
        {/* Nothing until the flags are known, so the old card doesn't flash up first */}
        {!features.isLoading && (warehouseOverview ? <OrdersOverview /> : <EbayOrdersStats />)}
        <EbayOrdersTable />
      </>
  );
}
